// import { mapGetters, mapActions } from "vuex";
import { createNamespacedHelpers } from 'vuex';
import Search from "@/components/common/Search/Search.vue";
import moment from 'moment';
import showToast from '@/util/toast';
import Swal from "sweetalert2";
import { HttpStatusCode } from 'axios';
import ModelService from "@/services/model.service";

const authMapper = createNamespacedHelpers('global/auth');
const modelMapper = createNamespacedHelpers('model');
const globalMapper = createNamespacedHelpers('global');
const modelDetectorMapper = createNamespacedHelpers('detector/model');

import {
  Table,
  TableColumn,
  DropdownMenu,
  DropdownItem,
  Dropdown,
  Tag,
  Pagination,
  Tooltip,
  Button,
} from "element-ui";


export default {
  components: {
    [Table.name]: Table,
    [TableColumn.name]: TableColumn,
    [Dropdown.name]: Dropdown,
    [DropdownItem.name]: DropdownItem,
    [DropdownMenu.name]: DropdownMenu,
    [Tag.name]: Tag,
    [Pagination.name]: Pagination,
    [Button.name]: Button,
    [Tooltip.name]: Tooltip,
    Search,
  },
  data() {
    return {
      filesList: [],
      selectedUsers: [],
      modelName: null,
      idSelected: null,
      dataOpt: {},
      formOpt: {
        key: "",
        value: "",
      },
      isLoading: false,
      newModelName: "",
      pageSize: 5,
      dropdownUserOpen: false,
      userList: [],
      searchedUser: '',
      receiveUserList: [],
      allowShareData: false,
      booleanOptions: [
        { value: true, text: 'True' },
        { value: false, text: 'False' },
      ],
      searchKeyOpt: '',
      typeOfDataOpt: {}
    };
  },
  async mounted() {
    await this.getList({ username: this.username, page: this.offset, limit: this.pageSize });
  },
  computed: {
    ...authMapper.mapState(['username']),
    ...modelMapper.mapGetters([
      "getListModel",
      "getSearchModel",
      "getOffsetModel",
      "getTablePerPageModel",
      "getTotal"
    ]),


    searchKey: {
      set(newValue) {
        this.$store.commit("model/SET_SEARCH_MODEL", newValue);
      },
      get() {
        return this.getSearchModel;
      }
    },
    offset: {
      set(newValue) {
        this.$store.commit("model/SET_OFFSET_MODEL", newValue);
      },
      get() {
        return this.getOffsetModel;
      },
    },
    modelSelected() {
      return (
        this.getTablePerPageModel?.find((model) => model.id === this.idSelected)
          ?.model_name || ""
      );
    },
    searchUserPlaceholder() {
			return this.$t('userSearchPlaceholder');
    },
    searchedUserList() {
			let selectedUserList = this.receiveUserList.map((user) => user.userName);
			let filteredUserList = this.userList.filter(
				(username) =>
					username.includes(this.searchedUser) && !selectedUserList.includes(username)
			);
			return filteredUserList;
    },
    getDataOpt() {
      let searchTerm = this.searchKeyOpt.toLowerCase();
      return Object.entries(this.dataOpt).reduce((filtered, [key, value]) => {
        if (key.toLowerCase().includes(searchTerm)) {
          filtered[key] = value;
        }
        return filtered;
      }, {});
      
    }
  },
  
  methods: {
    ...authMapper.mapActions(['getUserList']),
    ...modelMapper.mapActions([
      "getList",
      "renameModel",
      "deleteModel",
      "getSharedModelUser",
      "shareModel",
      "deleteSharedModel"
    ]),
    ...globalMapper.mapActions(['setSpinner']),
    ...modelDetectorMapper.mapActions(['retrieveModels']),
    
    /**
     * Handle event when click on Edit model
     */
    async handleUpdateName(id) {
      this.$bvModal.show("rename-model");
      this.idSelected = id;
    },

    /**
     * handle event click on button Delete model
     * @param {string} id Model id
     */
    async handleDeleteModel(id) {
      this.idSelected = id;

      const result = await Swal.fire({
        title: this.$t('confirnDelete'),
				text: `${this.$t('model')} ${this.modelSelected} ${this.$t('deleteModelText')}`,
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#f5365c",

        confirmButtonText: this.$t('confirmYes'),
        cancelButtonText: this.$t('confirmNo')
      });
      if (result.isConfirmed) {
        try {
          this.setSpinner(true);
					await this.deleteModel({
						username: this.username,
						model_name: this.modelSelected,
						model_id: this.idSelected,
					});

					showToast({
						vueInstance: this,
						type: 'success',
						message: this.$t('successDeleteModel'),
					});

					await this.retrieveModels({ username: this.username }); // retrieve for update detector page
          await this.getList({username: this.username, page: this.offset, limit: this.pageSize });
          this.setSpinner(false)
          this.idSelected = "";
        } catch (error) {
					showToast({
						vueInstance: this,
						type: 'danger',
						message: this.$t('failDeleteModel'),
          });
          this.setSpinner(false)
        }
      }
    },

    async handleChangeOffset(page) {
      await this.getList({username: this.username, page: page, limit: this.pageSize });
    },
    /**
     * Handle event Rename model
    */
    async handleUpdateModelName() {
      if (!this.newModelName || !this.idSelected) return;
      this.setSpinner(true);
      let responseStatus = await this.renameModel({
        modelId: this.idSelected,
        username: this.username,
        modelName: this.modelSelected,
        newModelName: this.newModelName
      })

      if (responseStatus !== 200) {
				showToast({
					vueInstance: this,
					type: 'error',
					message: this.$t('fail'),
				});
        this.setSpinner(false);
        return;
      }
			showToast({
				vueInstance: this,
				type: 'success',
				message: this.$t('success'),
      });
      await this.getList({username: this.username, page: this.offset, limit: this.pageSize });
      await this.retrieveModels({ username: this.username });
      this.setSpinner(false);
      this.idSelected = "";
      this.newModelName = "";
    },

    handleCloseRename() {
      this.newModelName = "";
    },


    formatDate(value) {
      if (value) {
        return moment(String(value)).format('YYYY/MM/DD HH:mm')
      }
    },

    //#region Share models

    /**
     * Handle the event click on Share model
     * @param {*} model Model infomation dictionary
     */
    async onShareModel(model) {
			// Get share user history
			this.selectedShareModel = model.model_name;
			this.userList = await this.getUserList();
			this.userList = this.userList.filter((user) => user !== this.username);

			let params = {
				model_name: model.model_name,
				user: this.username,
			};
			let receiveUserList = await this.getSharedModelUser(params);
			let receiveUserListUnique = [
				...new Map(receiveUserList.map((m) => [m.receive_user, m])).values(),
			];
			let indexUser = 0;
			for (let user in receiveUserListUnique) {
				if (!this.userList.includes(receiveUserListUnique[user]['receive_user'])) {
					indexUser = receiveUserListUnique.indexOf(
						receiveUserListUnique[user]['receive_user']
					);
					receiveUserListUnique.splice(indexUser, 1);
				}
			}
			this.receiveUserList = receiveUserListUnique.map((user) => {
				return {
					userName: user.receive_user,
					status: user.status,
					shareId: user._id.$oid,
				};
			});
			this.searchedUser = '';
			this.$bvModal.show('share-model-modal');
    },

    /**
     * Close modal share model
     */
    onCloseShareModal() {
			this.dropdownUserOpen = false;
			this.allowShareData = false;
			this.$bvModal.hide('share-model-modal');
    },
    onClickOutSide() {
			this.dropdownUserOpen = false;
    },
    focusSearchUserInput() {
			this.dropdownUserOpen = true;
			this.searchedUser = '';
    },
    
    // Select user for sharing
    onSelectUser(username) {
			let body = {
				userName: username,
				status: 0,
			};
			this.searchedUser = username;
			this.receiveUserList.push(body);
			this.dropdownUserOpen = false;
    },
    /**
     * Delete shared model
     * @param {string} user username
     * @param {int} index 
     */
    onClickDeleteShareUser(user, index) {
			if (user.status == 0) {
				this.receiveUserList.splice(index, 1);
			} else {
				let params = {
					share_id: user.shareId,
        };
				this.deleteSharedModel(params);
				this.receiveUserList.splice(index, 1);
			}
    },

    /**
     * Handle share model
     */
    async startShareModel() {
			let userList = this.receiveUserList.filter((user) => user.status == 0);
			userList = userList.map((user) => user.userName);
			let body = {
				model_name: this.selectedShareModel,
				request_user: this.username,
				receive_users: userList,
			};
			try {
				await this.shareModel({ body, allowShareData: this.allowShareData });
				this.$bvModal.hide('share-model-modal');
				showToast({
					vueInstance: this,
					type: 'success',
					message: this.$t('shareModalShareSuccess'),
				});
			} catch (err) {
				showToast({
					vueInstance: this,
					type: 'danger',
					message: this.$t('shareModalShareFailed'),
				});
			}
			this.dropdownUserOpen = false;
		},
    //#endregion
    
    /**
     * Show modal and get options model
     * @param {*} id modelId
     */
    async onClickEditModelOpt(id) {
      this.$bvModal.show("edit-modal-opt");

      this.idSelected = id;
      // Get options from model id
      let response = await ModelService.getModelOptions(this.idSelected);
      this.typeOfDataOpt = {}
      this.dataOpt = response?.data?.opt || {};
      Object.keys(this.dataOpt).forEach(key => {
        this.typeOfDataOpt[key] = typeof (this.dataOpt[key]);
      });
    },

    /**
     * Handle edit options model
     * @returns 
     */
    async handleEditOpt() {
      let response = await ModelService.updateModelOptions(this.idSelected, {
        "opt": this.dataOpt
      })
      if (response.status != HttpStatusCode.Ok) {
				showToast({
					vueInstance: this,
					type: 'error',
					message: this.$t('fail'),
				});
        
        return;
			}
			showToast({
				vueInstance: this,
				type: 'success',
				message: this.$t('success'),
      });
    },
    handleCloseEditOpt() {
      this.idSelected = null;
      this.dataOpt = {};
    },
    /**
     * Revert Option model to the default
     */
    async revertOpt() {
      this.$bvModal.hide("edit-modal-opt");
      if (!this.idSelected) return;
      let response = await ModelService.revertModelOptions(this.idSelected)
      if (response.status != HttpStatusCode.Ok) {
				showToast({
					vueInstance: this,
					type: 'error',
					message: this.$t('fail'),
				});
        
        return;
			}
			showToast({
				vueInstance: this,
				type: 'success',
				message: this.$t('success'),
      });
    },

    onChangeInputValue(key, value) {

      console.log(key, value)
      if (value === "") {
        this.dataOpt[key] = ""
      } else if (this.typeOfDataOpt[key] === "object") {
        this.dataOpt[key] = JSON.parse(value)
      } else if (this.typeOfDataOpt[key] === "number"){
        this.dataOpt[key] = JSON.parse(value.replace(",","."))
      } else {
        this.dataOpt[key] = value
      }

    },

    convertLanguage(key) {
      return this.$t(key)
    }
  },
  

};
